const OrderValidation = (statusCode) => {
  if (
    statusCode === "1003" ||
    statusCode === "2001" ||
    statusCode === "2002" ||
    statusCode === "2003" ||
    statusCode === "3001" ||
    statusCode === "3002" ||
    statusCode === "3003" ||
    statusCode === "3004" ||
    statusCode === "2005"
  ) {
    document.getElementById("modality").required = false;
    document.getElementById("body_part").required = false;
    // document.getElementById("appointment").required = false;
    // document.getElementById("time").required = false;
    document.getElementById("firstname").required = false;
    document.getElementById("lastname").required = false;
    document.getElementById("DOB").required = false;
    document.getElementById("contact").required = false;
    document.getElementById("comment").required = false;
  }
  if (statusCode === "2004" || statusCode === "1001" || statusCode === "1002") {
    document.getElementById("modality").required = true;
    document.getElementById("body_part").required = true;
    // document.getElementById("appointment").required = true;
    // document.getElementById("time").required = true;
    document.getElementById("firstname").required = true;
    document.getElementById("lastname").required = true;
    document.getElementById("DOB").required = true;
    document.getElementById("contact").required = true;
  }
  if (statusCode === "1002") {
    document.getElementById("comment").required = true;
  }
  if (statusCode === "1004") {
    document.getElementById("firstname").required = false;
    document.getElementById("lastname").required = false;
    document.getElementById("modality").required = true;
    document.getElementById("body_part").required = true;
    // document.getElementById("appointment").required = true;
    // document.getElementById("time").required = true;

    document.getElementById("DOB").required = true;
    document.getElementById("contact").required = true;
    document.getElementById("comment").required = true;
  }
  if (statusCode === "1004") {
    document.getElementById("firstname").value = "";
    document.getElementById("lastname").value = "";
  }
  if (statusCode === "2004") {
    document.getElementById("comment").required = true;
  }
};

export default OrderValidation;
